import React from "react";
import { Link } from "react-router-dom";
import ProfileImageContainer from "../core/ProfileImageContainer";

const PlayerCard = ({ player, club_data, sortBy, gradientStyle, index }) => {

  // Function to get extra stat based on sort selection
  const getExtraStat = () => {
    switch (sortBy) {
      case "team":
        return player.team;
      case "gp":
        return `${player.gp} GP`;
      case "classification":
        return player.classification;
      case "reg_date":
        return `${player.reg_date}`;
      case "g":
        return `${player.g} G`;
      case "a":
        return `${player.a} A`;
      case "points":
        return `${player.points} PTS`;
      case "pims":
        return `${player.pims} PIMs`;
      default:
        return player.institution;
    }
  };

  // Default pending & suspended status
  console.log("Player data:", player);
  player.pending = player.player.active === 2 || false;
  // Determine if player is suspended based on active status
  player.suspended = player.player.active === 3 || player.player.active === 4 || false;
  console.log("Player suspended status:", player.suspended);

  return (
    <Link
      to={`/player/${player.player.id}`}
      className="no-underline group"
    >
      <div
        key={index}
        className="w-20 max-xs:max-h-40 max-sm:w-28 sm:w-40 xxs:px-0.5 pb-2 items-center justify-start flex flex-col text-centre rounded-lg"
      >
        <div className={`my-1 sm:mb-2 relative transform transition-transform duration-200 ease-in-out group-hover:scale-105 
        ${player.pending ? "shadow-[0_0_12px_4px_rgba(255,255,70,0.6)]" : ""} 
        ${player.suspended ? "shadow-[0_0_12px_4px_rgba(255,70,70,0.6)]" : ""}`}>

          <div className="max-xs:w-20 max-xs:h-20 max-sm:w-28 sm:w-28 max-sm:h-28 sm:h-28">
            {/* Player image */}
            <ProfileImageContainer
              player={player.player.id}
              alt={`${player.player.forename} ${player.player.surname}`}
              club={club_data.id}
              backup={club_data.short.toLowerCase()}
              extraClasses="rounded-t"
            />
          </div>
          <div
            className="max-xs:w-20 max-sm:w-28 sm:w-28 h-1"
            style={gradientStyle}
          ></div>
        </div>

        <div className="text-center">
          {/* Player name */}
          <h2 className="leading-tight text-xxs mb-0.5 xs:text-xsm transition-colors duration-200 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
            {player.player.forename} {player.player.surname}
          </h2>
          <p className="text-darken text-xxxs xs:text-xxs font-light leading-tight">
            {/* Extra stat based on sort selection */}
            {getExtraStat()}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default PlayerCard;
